(function () {
  'use strict';

  angular.module('sempraWebapp').service('softenedWaterSubsystemUtils', softenedWaterSubsystemUtilsService);

  /** @ngInject */
  function softenedWaterSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getSoftenedWaterSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.SOFTENED_WATER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_MIN_NIVO_OMEKS_VODE: 'OP_MIN_NIVO_OMEKS_VODE',
      OP_CRPKA_OMEKS_VODE_GRE_MZS: 'OP_CRPKA_OMEKS_VODE_GRE_MZS',
      OP_MAX_NIVO_OMEKS_VODE: 'OP_MAX_NIVO_OMEKS_VODE',
      OP_TLAK_OMEKSANE_VODE: 'OP_TLAK_OMEKSANE_VODE',
      OP_CRPKA_OMEKS_VODE_RAD: 'OP_CRPKA_OMEKS_VODE_RAD',
      OP_EMV_SPR_OMEKSANA_VODA: 'OP_EMV_SPR_OMEKSANA_VODA',
      OP_BUTTON_7M6_BR_RESET: 'OP_BUTTON_7M6_BR_RESET',
      OP_COV_7M6_BROJ_SATI_RADA: 'OP_COV_7M6_BROJ_SATI_RADA',
      properties: {
        OP_MIN_NIVO_OMEKS_VODE: getFeedPropertiesObject('OP_MIN_NIVO_OMEKS_VODE'),
        OP_CRPKA_OMEKS_VODE_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_OMEKS_VODE_GRE_MZS'),
        OP_MAX_NIVO_OMEKS_VODE: getFeedPropertiesObject('OP_MAX_NIVO_OMEKS_VODE'),
        OP_TLAK_OMEKSANE_VODE: getFeedPropertiesObject('OP_TLAK_OMEKSANE_VODE'),
        OP_CRPKA_OMEKS_VODE_RAD: getFeedPropertiesObject('OP_CRPKA_OMEKS_VODE_RAD'),
        OP_EMV_SPR_OMEKSANA_VODA: getFeedPropertiesObject('OP_EMV_SPR_OMEKSANA_VODA'),
        OP_BUTTON_7M6_BR_RESET: getFeedPropertiesObject('OP_BUTTON_7M6_BR_RESET'),
        OP_COV_7M6_BROJ_SATI_RADA: getFeedPropertiesObject('OP_COV_7M6_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({

    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }
  }
})();
